export const getMockReportData = (reportType, filters = {}) => {
  const baseData = {
    reportType,
    period: filters.period,
    currency: filters.currency,
    isMockData: true,
  };

  if (reportType === "payables") {
    return {
      ...baseData,
      summary: {
        totalPayables: 50000,
        costOfGoodsSold: 200000,
        operatingCashOutflow: 80000,
        daysPayableOutstanding: 45,
        payableTurnover: 8,
        payableToRevenueRatio: 25,
      },
      details: {
        totalPayables: 50000,
        payablesByVendor: {
          "المورد الأول": { totalAmount: 20000, transactionCount: 5 },
          "المورد الثاني": { totalAmount: 15000, transactionCount: 3 },
          "المورد الثالث": { totalAmount: 10000, transactionCount: 2 },
        },
        recentPayments: [
          {
            description: "دفع للمورد الأول",
            amount: 5000,
            type: "دفع للموردين",
            date: "2024-01-15",
          },
        ],
        agingAnalysis: {
          current: 30000,
          days31_60: 15000,
          days61_90: 5000,
          over90: 0,
        },
      },
    };
  }

  return {
    ...baseData,
    summary: {
      revenue: 100000,
      expenses: 60000,
      netIncome: 40000,
    },
    details: {
      revenue: { مبيعات: { amount: 100000, count: 1 } },
      expenses: { "مصاريف عامة": { amount: 60000, count: 1 } },
    },
    ratios: {
      grossMargin: 40,
      netMargin: 40,
      expenseRatio: 60,
    },
  };
};
